export default __webpack_public_path__ + "80c11042233a882660d23db9138a6bad.svg";